import {
  API_ENDPOINTS as SERVICE_WORKER_API_ENDPOINTS,
  ApiBaseRoute as SERVICE_WORKER_ApiBaseRoute
} from '../../../../ServiceWorker/src/constants/api-endpoints.constants';

export class API_ENDPOINT_KEYS {
  static readonly getFormConfig = 'getFormConfig';
  static readonly getMaatAuditPlanConfigAndResponse = 'getMaatAuditPlanConfigAndResponse';
  static readonly getMaatJobConfigAndResponse = 'getMaatJobConfigAndResponse';
  static readonly getMaatJobItemConfigAndResponse = 'getMaatJobItemConfigAndResponse';
  static readonly getMaatNcqConfigAndResponse = 'getMaatNcqConfigAndResponse';
  static readonly getMaatNcqConfigWithEmptyResponse = 'getMaatNcqConfigWithEmptyResponse';
  static readonly getMaatUserConfigAndResponse = 'getMaatUserConfigAndResponse';
  static readonly getMaatSorDescriptionConfigAndResponse = 'getMaatSorDescriptionConfigAndResponse';
  static readonly getOrganisationConfigAndResponse = 'getOrganisationConfigAndResponse';
  static readonly getOrganisationConfigWithEmptyResponse = 'getOrganisationConfigWithEmptyResponse';
  static readonly getTeamConfigAndResponse = 'getTeamConfigAndResponse';
  static readonly getTeamConfigWithEmptyResponse = 'getTeamConfigWithEmptyResponse';
  static readonly getUserConfigAndResponse = 'getUserConfigAndResponse';
  static readonly getUserConfigWithEmptyResponse = 'getUserConfigWithEmptyResponse';
  static readonly getInspectionConfigAndResponse = 'getInspectionConfigAndResponse';
  static readonly getInspectionCalendarConfigAndResponse = 'getInspectionCalendarConfigAndResponse';
  static readonly getInspectionListConfigForBatch = 'getInspectionListConfigForBatch';
};

export { SERVICE_WORKER_ApiBaseRoute as ApiBaseRoute };

export { SERVICE_WORKER_API_ENDPOINTS as API_ENDPOINTS };
